import { Component, OnInit, ViewChild, AfterViewInit }              from '@angular/core';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';

import { AlertService, BatchService } 					    	    from '../_services';
import { Globals }                                                  from '../_helpers';

import { NgxSpinnerService }                                        from 'ngx-spinner';


@Component({
  selector: 'app-home',
  templateUrl: './complete-batch.component.html'
})


export class CompletebatchComponent implements OnInit {
  	
  	localData = {};
  	batchlist = [];

  	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private batchService: BatchService,
         private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private globals: Globals,
    ) {}

  	ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));

        this.getCompletedBatch();
  	}


  	public getCompletedBatch(){
		this.spinner.show();
		this.batchService.getCompletedBatchDetails(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
        .pipe(first())
        .subscribe(
	        data => {
                if(data.code == 1000){
                    this.batchlist = data.batches;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.router.navigateByUrl('/login');
                }
                this.spinner.hide();
	        },
	        error => {
	            this.alertService.error(error);
	            this.spinner.hide();
	        }
	    );
	}
    public gotoDashboard(){
        var parms = this.globals.getRandUrl('dashboard');
        localStorage.setItem('urlStep', JSON.stringify({set:parms}));      
        this.router.navigateByUrl('/dashboard/'+parms);
    }  
}
